<template>
  <div />
</template>

<script>
import config from '@/config.js';
export default {
  data () {
    return {
    };
  },
  methods: {
  },
  mounted: function () {
    const _this = this;
    let accessToken = '';
    let pages = '';
    accessToken = this.$route.query.accessToken;
    pages = this.$route.query.pages;

    console.log('=== redirectTo.vue 开始执行 ===');
    console.log('accessToken', accessToken);
    console.log('pages', pages);
    console.log('window.CookieUtil是否存在:', !!window.CookieUtil);
    console.log('config.localTokenName:', config.localTokenName);
    if (
      accessToken !== 'null' &&
      accessToken !== '' &&
      accessToken !== undefined &&
      accessToken !== null &&
      pages !== undefined &&
      pages !== null &&
      pages !== '' &&
      pages !== 'null'
    ) {
      // 获取accessToken进行请求获取gjss-authtoken（安全性考虑）
      this.loading = true;
      this.logining = true;
      // 使用与路由守卫相同的cookie工具
      console.log('设置token前，清除旧token');
      window.CookieUtil.unset(config.localTokenName);

      console.log('设置新token:', accessToken);
      window.CookieUtil.set(config.localTokenName, accessToken);
      // 验证token是否设置成功
      var savedToken = window.CookieUtil.get(config.localTokenName);
      console.log('设置后获取到的token:', savedToken);

      if (savedToken === accessToken) {
        console.log('✅ Token设置成功！');
      } else {
        console.log('❌ Token设置失败！');
      }

      console.log('准备跳转到页面:', pages);
      _this.$router.push({ path: pages });
    }
  }
};
</script>

<style scoped>
/* Your component's styles go here */
</style>
